module.exports = __webpack_public_path__ + "img/7.e6f24a4a.jpg";